module.exports = __webpack_public_path__ + "static/media/bluestone.a694459b.jpg";